import FloatingInputLabel from '@components/common/floating-input/floating-input'

type Props = {
  id: string
  name: string
  type?: string
  label?: string
  labelSize?: string
  helpTextTop?: string
  helpText?: string
  errorText?: string
  errorList?: Array<string>
  autoFocus?: boolean
  required?: boolean
  value?: string
  disabled?: boolean
  onChange: (e: React.FormEvent<HTMLInputElement>) => void
  onKeyUp?: (e: React.FormEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FormEvent<HTMLInputElement>) => void
  toolTipText?: string
  list?: string
} & typeof defaultProps

const defaultProps = {
  type: 'text',
  label: '',
  helpTextTop: '',
  helpText: '',
  errorText: '',
  errorList: [],
  required: false,
  disabled: false,
}

const FloatingInputContainer = ({
  helpTextTop,
  id,
  label,
  name,
  type,
  value,
  required,
  onChange,
  onKeyUp,
  onBlur,
  autoFocus,
  disabled,
  helpText,
  errorText,
  errorList,
  toolTipText,
  list,
}: Props): JSX.Element => {
  return (
    <div className="flex flex-col space-y-1">
      {helpTextTop && (
        <div className="text-grey text-sm font-400">{helpTextTop}</div>
      )}
      <FloatingInputLabel
        id={id}
        label={label}
        name={name}
        type={type}
        value={value}
        required={required}
        onChange={onChange}
        onKeyUp={onKeyUp}
        onBlur={onBlur}
        autoFocus={autoFocus}
        disabled={disabled}
        toolTipText={toolTipText}
        list={list}
      />
      {helpText && <div className="text-grey text-sm font-400">{helpText}</div>}
      {errorText && (
        <div role="alert" className="text-red-200 text-sm font-400">
          {errorText}
        </div>
      )}
      {errorList &&
        errorList.map((error, idx) => (
          <div
            role="alert"
            data-testid="input-error"
            className="text-red-200 text-sm font-400"
            key={idx}
          >
            {error}
          </div>
        ))}
    </div>
  )
}

FloatingInputContainer.defaultProps = defaultProps
export default FloatingInputContainer
